import IconButton from '@mui/material/IconButton';
import { makeStyles } from 'tss-react/mui';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import LocationIcon from '@mui/icons-material/LocationOn';
import PropTypes from 'prop-types';
import React from 'react';
import { getLocationDetails } from '../../helpers/getLocationDetails';
import Link from '@mui/material/Link';
import CreationTime from './CreationTime';

const useStyles = makeStyles()(() => ({
  iconButton: {
    marginRight: '-3px',
    paddingBottom: '2px',
    fontSize: '1rem',
  },
  typography: {
    lineHeight: 1,
  },
}));

const SubHeader = props => {
  const { classes } = useStyles();

  const {
    createdAt,
    readTime,
    wordCount,
    location,
    showWordCount,
    hideLocationIcon,
    isWhite,
  } = props;

  const { locationTitle, locationSubtitle, locationLink } = getLocationDetails(
    location,
  );

  return (
    <>
      <Typography
        variant="overline"
        display="inline"
        color={isWhite ? 'secondary' : 'textSecondary'}
        className={classes.typography}
      >
        <CreationTime createdAt={createdAt} />
        {readTime ? (
          <>
            <span> · </span>
            <Tooltip
              title={
                showWordCount
                  ? `${Math.ceil(readTime)} min read`
                  : `${wordCount} words`
              }
              placement="bottom"
            >
              <span>
                {showWordCount
                  ? `${wordCount} words`
                  : `${Math.ceil(readTime)} min read`}
              </span>
            </Tooltip>
          </>
        ) : (
          <></>
        )}
        {location && location.countryCode && (
          <>
            <span> · </span>
            <Link color="inherit" href={locationLink} legacyBehavior>
              <a className="hoverline">
                {!hideLocationIcon && (
                  <IconButton
                    size="small"
                    edge="start"
                    disabled
                    aria-label={locationTitle}
                  >
                    <LocationIcon className={classes.iconButton} />
                  </IconButton>
                )}
                <Tooltip title={locationSubtitle} placement="bottom">
                  <span>{locationTitle}</span>
                </Tooltip>
              </a>
            </Link>
          </>
        )}
      </Typography>
    </>
  );
};

SubHeader.defaultProps = {
  location: {},
};

SubHeader.propTypes = {
  createdAt: PropTypes.string,
  location: PropTypes.objectOf(PropTypes.any),
};

export default SubHeader;
